/* Single source of truth for $KEK facts, links and content. */

export const CONTRACT = 'waxpepetoken';
export const MAX_SUPPLY_LABEL = '420.69T';
export const MAX_SUPPLY_FULL = '420,690,000,000,000';

export const TG_URL = 'https://t.me/wax_pepe_official';
export const X_URL = 'https://twitter.com/KEK_Official';
export const EMAIL = 'marketing@wax-pepe.vip';
export const ALCOR_SWAP =
  'https://alcor.exchange/swap-widget?input=wax-eosio.token&output=kek-waxpepetoken&market=waxpepe.gm';
export const ALCOR_CHART = 'https://alcor.exchange/trade/kek-waxpepetoken_wax-eosio.token';
export const ANT_BUBBLES_URL = 'https://bubbles.wax-pepe.vip';

export const CLOUD_WALLET = 'https://www.mycloudwallet.com/';
export const ANCHOR_GUIDE = 'https://www.youtube.com/watch?v=99IsjN6x1Bc';
export const WAXP_GUIDE = 'https://www.youtube.com/watch?v=B4q59KIf4ys';

export const DISCLAIMER =
  'Wax Pepe and $KEK have no association with the WAX team, Matt Furie, or any related creation. $KEK is a community meme token with no intrinsic value or expectation of financial return. There is no formal issuer team, roadmap, or guaranteed development program. The token is provided for entertainment purposes only. Users are responsible for ensuring compliance with applicable regional laws and restrictions before interacting with crypto-assets.';
